var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5547 7.57769L13.1016 6.03081C13.7565 5.43388 14.6162 5.11225 15.5022 5.13276C16.3881 5.15327 17.232 5.51434 17.8586 6.14095C18.4852 6.76755 18.8463 7.61149 18.8668 8.49741C18.8873 9.38332 18.5657 10.2431 17.9687 10.898L15.7578 13.1011C15.4392 13.421 15.0605 13.6747 14.6436 13.8479C14.2266 14.0211 13.7796 14.1102 13.3281 14.1102C12.8767 14.1102 12.4296 14.0211 12.0127 13.8479C11.5957 13.6747 11.2171 13.421 10.8984 13.1011",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4459 16.4222L10.899 17.969C10.244 18.566 9.3843 18.8876 8.49838 18.8671C7.61247 18.8466 6.76853 18.4855 6.14192 17.8589C5.51532 17.2323 5.15425 16.3884 5.13374 15.5024C5.11323 14.6165 5.43486 13.7568 6.03179 13.1018L8.24273 10.8987C8.56137 10.5789 8.94002 10.3251 9.35697 10.1519C9.77391 9.97879 10.2209 9.88965 10.6724 9.88965C11.1239 9.88965 11.5709 9.97879 11.9879 10.1519C12.4048 10.3251 12.7835 10.5789 13.1021 10.8987",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.c9592eb6fe3c3ede4d51f82b6ee6b9fe.svg";
export { ForwardRef as ReactComponent };